import Image from 'next/image';
import Link from 'next/link';
import { parseHtml } from '@/lib/parse-html';
import FaqDrawerList, { FaqDrawerListProps } from '@/components/_rebrand/FaqDrawerList';

const displayProps = {
  title: 'Frequently asked questions',
  description: (
    <p className="text-p2 md:text-p1 text-gray-700 rich-text">
      Can’t find the answer here? Our <Link href="https://help.front.com/en/contact-us" target="_blank" style={{ textDecoration: 'underline' }}>support team</Link> is happy to help.
    </p>
  ),
  drawers: [],
  darkBackground: false,
} as FaqDrawerListProps;


interface FaqItemFromCraft {
  question: string;
  answer: string;
}

const formFaqItems = (items: FaqItemFromCraft[]): FaqDrawerListProps['drawers'] => {
  const drawers: FaqDrawerListProps['drawers'] = items.map((item) => ({
        question: item.question,
        answer: parseHtml(item.answer)
  }));

  return drawers;
}

const setDynamicDisplayPropAttributes = (data: FaqItemFromCraft[]) => {
  displayProps.drawers = formFaqItems(data);
};

const FAQ = ({ entry }) => {
  const data = entry?.moduleProductFaq;

  setDynamicDisplayPropAttributes(data);

  return (
    <FaqDrawerList {...displayProps} />
  );
};

export default FAQ;

